import axios from "axios";

export default axios.create({
  baseURL: "https://api.metal-m.bg/api"
  //baseURL: "https://localhost:44371/api"
});
